<template>
<div id="camputo_plazos" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="COMPUTO DE PLAZOS" class="elevation-1 px-5 py-3" >
          <br>
          <v-tabs grow style="margin-bottom: 30px;" >
            <v-tabs-slider color="primary" ></v-tabs-slider>
            <v-tab :key="'in-view'" >Vista Previa</v-tab>
            <v-tab :key="'in-report'" >Generar en Reporte</v-tab>

            <v-tab-item :key="'in-view'" >
               <v-card-text>
                  <v-card-title>
                    <span class="headline" ></span>
                  </v-card-title>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                        <v-row row wrap>
                        <v-col cols="12" sm="3" md="3" lg="3" >
                          <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field clearable v-on="on" v-model="model.fecha_de" label="Fecha Pago Pedimento Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                  :rules="(model.numero_pedimento!=undefined && model.numero_pedimento.toString().trim()!='')?[validaAnio, validaDiasPreview, validaFecha]:[rules.required, validaDiasPreview, validaAnio, validaFecha]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu1 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" lg="3" >
                          <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field clearable v-on="on" v-model="model.fecha_a" label="Fecha Pago Pedimento Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                  :rules="(model.numero_pedimento!=undefined && model.numero_pedimento.toString().trim()!='')?[validaAnio, validaDiasPreview, validaFecha]:[rules.required, validaDiasPreview, validaAnio, validaFecha]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu2 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" md="2" sm="2" lg="2">
                                <v-autocomplete v-model="model.clave_documento" 
                                    :items="claves" :hide-no-data="true"     
                                    clearable :loading="clave_loading"  
                                    :return-object="false"  label="Clave Documento">
                                </v-autocomplete>
                            </v-col>
                        <v-col cols="12" md="2" sm="2" lg="2">
                                <v-text-field label="Número Pedimento" clearable maxlength="20" 
                                v-model="model.numero_pedimento" :rules="[validaPedimento]">  
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="1" sm="1" lg="1">
                                <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                                  <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                                </v-btn>
                            </v-col>                                                  
                      </v-row> 

                        <v-row no-row wrap>                            
                            
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-autocomplete v-model="model.activo" :items="list_activos" :hide-no-data="true" 
                                    item-text="text" item-value="id"                                    
                                    :return-object="false"  label="Activo Fijo"                                     
                                    >
                                </v-autocomplete>
                            </v-col>                      
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-text-field label="Fracción" clearable v-model="model.fraccion" maxlength="10">  
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="1" sm="1" lg="1">
                                <v-btn icon title="Lista Fracciones" @click="dialog3 = !dialog3" v-tippy>
                                  <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-autocomplete v-model="model.valor_pendiente" 
                                    :items="valor_pendiente_array" :hide-no-data="true"
                                    @change="set_columns()"
                                    :return-object="false"  label="Pendiente Retorno">
                                </v-autocomplete>
                            </v-col>   
                            <v-col cols="12" md="2" sm="2" lg="2">
                              <v-autocomplete v-model="model.regla_plazo" 
                                    :loading="plazo_loading" clearable
                                    :items="reglas_plazo" :hide-no-data="true"
                                    :return-object="false"  label="Regla de Plazo">
                                </v-autocomplete>
                            </v-col>                                              
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-btn color="info" @click="genera_consulta()" >
                                    <v-icon>done</v-icon>Consultar
                                </v-btn>              
                            </v-col>
                      </v-row>                    
                    </v-container>

                  </v-form>
                </v-card-text>
                
                <v-card-text>                  
                  <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-1 pa-2">
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontró ningun registro</v-alert>
                    </template>
                    
                    <template slot="beforeTable">
                        <div style="display: flex;justify-content: space-between;">
                            <div style="text-align:left" >
                                Fecha de Actualización: {{fecha_actualizacion}}
                            </div>
                            <div style="text-align:right">                                
                                <v-btn small color="blue" title="Calcular Plazos" v-tippy
                                    @click="calcular_plazos"
                                  >
                                    <v-icon dark>mdi-refresh</v-icon> Calcular Plazos
                                </v-btn>                                
                            </div>
                            <div style="text-align:right" v-if="datos.length>0">
                                <exportar-excel :data="datafiltered" :exportFields="encabezadosExportar" name="ComputoPlazos.xlsx">
                                    <v-btn small color="green" title="Exportar Excel" v-tippy>
                                        <v-icon dark>mdi-table</v-icon> Exportar
                                    </v-btn>
                                </exportar-excel>
                            </div>
                        </div>
                        <v-divider></v-divider>
                        <div style="display: flex;justify-content: space-between;">
                            <div style="text-align:center;" >
                              {{datafiltered.length}} registros
                            </div>
                            <div style="text-align:center;" >
                                TOTALES DE FILTRO
                            </div>
                            <div style="text-align:right">
                                <span>Valor Comercial Pendiente de Retorno: </span> <span style="font-size:18px;"><strong>{{ formatNumberDec(total_valor_pendiente_filtro, 2) }} </strong></span>
                                <br><span>Crédito IVA: </span> <span style="font-size:18px;"><strong>{{ formatNumberDec(suma_saldo_iva_filtro, 2) }} </strong></span>
                                <br><span>Crédito IEPS: </span> <span style="font-size:18px;"><strong>{{ formatNumberDec(suma_saldo_ieps_filtro, 2) }} </strong></span>
                            </div>
                        </div>
                    </template>

                    <template slot="clave_documento" slot-scope="props">
                      <div style="text-align:center">{{props.row.clave_documento}}</div>
                    </template>
                    <template slot="meses" slot-scope="props">
                      <div style="text-align:center">{{props.row.meses}}</div>
                    </template>
                    <template slot="no_pedimento" slot-scope="props">
                      <div style="text-align:center">{{props.row.no_pedimento}}</div>
                    </template>
                    <template slot="identificador" slot-scope="props">
                      <div style="text-align:center">{{props.row.identificador}}</div>
                    </template>
                    <template slot="fecha" slot-scope="props">
                      <div style="text-align:center">{{parseDate(props.row.fecha)}}</div>
                    </template>
                    <template slot="fecha_original" slot-scope="props">
                      <div style="text-align:center">{{parseDate(props.row.fecha_original)}}</div>
                    </template>
                    <template slot="fecha_vencimiento" slot-scope="props">
                      <div style="text-align:center">{{parseDate(props.row.fecha_vencimiento)}}</div>
                    </template>
                    <template slot="fraccion" slot-scope="props">
                      <div style="text-align:right">{{props.row.fraccion}}</div>
                    </template>
                    <template slot="valor_comercial" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDec(props.row.valor_comercial, 2)}}</div>
                    </template>
                    <template slot="valor_comercial_cargo" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDec(props.row.valor_comercial_cargo, 2)}}</div>
                    </template>
                    <template slot="abono" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDec(props.row.abono, 2)}}</div>
                    </template>
                    <template slot="valor_comercial_abono" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDec(props.row.valor_comercial_abono, 2)}}</div>
                    </template>
                    <template slot="valor_comercial_pendiente" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDec(props.row.valor_comercial_pendiente, 2)}}</div>
                    </template>
                    <template slot="abono_iva" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDec(props.row.abono_iva, 2)}}</div>
                    </template>
                    <template slot="abono_ieps" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDec(props.row.abono_ieps, 2)}}</div>
                    </template>
                    <template slot="saldo_iva" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDec(props.row.saldo_iva, 2)}}</div>
                    </template>
                    <template slot="saldo_ieps" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDec(props.row.saldo_ieps, 2)}}</div>
                    </template>

                    <template slot="afterTable">
                        <div style="display: flex;justify-content: space-between;">
                            <div style="text-align:left" >
                                <span v-if="conteo_vista_previa == 300 && conteo_total > 300">
                                    Máximo {{formatNumber(conteo_vista_previa)}} registros en Vista Previa<br>
                                    Para visualizarlos todos, debe generar un reporte
                                </span>
                                <span v-else>
                                    {{formatNumber(conteo_total)}} registros
                                </span>
                                
                            </div>
                            <div style="text-align:right">
                                <span>Valor Comercial Total Pendiente de Retorno: </span> <span style="font-size:18px;"><strong>{{ formatNumberDec(total_valor_pendiente, 2) }} </strong></span>
                                <br><span>Crédito Total IVA: </span> <span style="font-size:18px;"><strong>{{ formatNumberDec(suma_saldo_iva, 2) }} </strong></span>
                                <br><span>Crédito Total IEPS: </span> <span style="font-size:18px;"><strong>{{ formatNumberDec(suma_saldo_ieps, 2) }} </strong></span>
                                <br>Estos totales corresponden al periodo de 2015 a la fecha de actualización.
                            </div>
                        </div>
                        
                                          
                    </template>

                  
                  </v-client-table>
                </v-card-text>
            </v-tab-item>

            <v-tab-item :key="'in-report'" >
              <v-card-text>
                  <v-card-title>
                    <span class="headline" ></span>
                  </v-card-title>
                  <v-form ref="formreporte" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                        <v-row row wrap>
                        <v-col cols="12" sm="3" md="3" lg="3" >
                          <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field clearable v-on="on" v-model="model.fecha_de" label="Fecha Pago Pedimento Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                  :rules="(model.numero_pedimento!=undefined && model.numero_pedimento.toString().trim()!='')?[validaAnio, validaFecha]:[rules.required, validaAnio, validaFecha]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu3 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu3 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" lg="3" >
                          <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field clearable v-on="on" v-model="model.fecha_a" label="Fecha Pago Pedimento Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                  :rules="(model.numero_pedimento!=undefined && model.numero_pedimento.toString().trim()!='')?[validaAnio, validaFecha]:[rules.required, validaAnio, validaFecha]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu4 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu4 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>           
                        <v-col cols="12" md="2" sm="2" lg="2">
                            <v-autocomplete v-model="model.clave_documento" 
                                :items="claves" :hide-no-data="true"     
                                clearable :loading="clave_loading"  
                                :return-object="false"  label="Clave Documento">
                            </v-autocomplete>
                        </v-col>             
                        <v-col cols="12" md="2" sm="2" lg="2">
                                <v-text-field label="Número Pedimento" clearable maxlength="20" 
                                v-model="model.numero_pedimento" :rules="[validaPedimento]">  
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="1" sm="1" lg="1">
                                <v-btn icon title="Pegar Listado" @click="dialog2 = !dialog2" v-tippy>
                                  <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                                </v-btn>
                            </v-col>                                                  
                      </v-row> 

                        <v-row no-row wrap>                                                                                    
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-autocomplete v-model="model.activo" :items="list_activos" :hide-no-data="true" 
                                    item-text="text" item-value="id"                                    
                                    :return-object="false"  label="Activo Fijo"                                     
                                    >
                                </v-autocomplete>
                            </v-col>                      
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-text-field label="Fracción" clearable v-model="model.fraccion" maxlength="10">  
                                </v-text-field>
                            </v-col>   
                            <v-col cols="12" md="1" sm="1" lg="1">
                                <v-btn icon title="Lista Fracciones" @click="dialog4 = !dialog4" v-tippy>
                                  <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                                </v-btn>
                            </v-col>        
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-autocomplete v-model="model.valor_pendiente" 
                                    :items="valor_pendiente_array" :hide-no-data="true"
                                    @change="set_columns()"
                                    :return-object="false"  label="Pendiente Retorno">
                                </v-autocomplete>
                            </v-col>   
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-autocomplete v-model="model.regla_plazo" 
                                    :loading="plazo_loading" clearable
                                    :items="reglas_plazo" :hide-no-data="true"
                                    :return-object="false"  label="Regla de Plazo">
                                </v-autocomplete>
                            </v-col>  
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-btn color="success" @click="generar_reporte()" >
                                    <v-icon>done_all</v-icon>Generar Reporte
                                </v-btn>              
                            </v-col>   
                                                                        
                      </v-row>                    
                    </v-container>

                  </v-form>
                </v-card-text>
                
                <v-card-text>           
                  <v-refresh-button :funcion="cargar" />       
                  <v-client-table ref="vuetable2" :data="reportes" :columns="columns_reportes" :options="options_reportes" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontró ningun registro</v-alert>
                    </template>
                    
                    <template slot="actions" slot-scope="props" >
                      <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  
                  </v-client-table>
                </v-card-text>
            </v-tab-item>
          </v-tabs>              

        </base-material-card>
      </v-col>
    </v-row>

    <LoaderFraces ref="computoLoader" :mensajes="lista_mensajes" ></LoaderFraces>

  </v-container>

  <v-dialog v-model="dialog1" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de pedimentos</h5>
        <span>Uno por línea</span>
        <v-form ref="formListado" lazy-validation="" >
          <v-textarea outlined rows="15" v-model="listado" :rules="[validaListadoPreview]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="dialog1 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="generaConsultaListado();" >Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="dialog2" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de pedimentos</h5>
        <span>Uno por línea</span>
        <v-form ref="formListado" lazy-validation="" >
          <v-textarea outlined rows="15" v-model="listado" :rules="[validaListado]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="dialog2 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="generaReporteListado();" >Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="dialog3" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de fracciones</h5>
        <span>Una por línea</span>
        <v-form ref="formListadoFracciones" lazy-validation="" >
          <v-textarea outlined rows="15" v-model="listado_fracciones" :rules="[validaListadoFraccionPreview]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="dialog3 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="generaConsultaListadoFracciones();" >Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="dialog4" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de fracciones</h5>
        <span>Una por línea</span>
        <v-form ref="formListadoFracciones" lazy-validation="" >
          <v-textarea outlined rows="15" v-model="listado_fracciones" :rules="[validaListadoFraccion]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="dialog4 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="generaReporteListadoFracciones();" >Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>  

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";
import LoaderFraces from "@/components/LoaderFraces";
export default {
  components: {
    "v-refresh-button": RefreshButton,
    LoaderFraces,
  },
  created: function() {
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }
    this.loading = false;    
    this.fecha_actual = moment().format("DD-MM-YYYY")
    this.tipo = 1;
    this.model.rfc = this.$local_storage.get("rfc");
    this.model.usuario = this.$local_storage.get("id_usuario");    
    this.getClaves();
    //this.getAnios();  
    this.getReglasPlazo();  
    //this.getFracciones();
    this.cargar("inicio");
  },
  mounted: function(){
    this.get_primer_consulta(); //Se solicitó que al entrar a la vista cargue desde 2015 y solo los valores pendientes de retorno
  },
  computed: {
    datafiltered() {
        let result = [];
        if (this.$refs.vuetable != null) {
            result = this.$refs.vuetable.allFilteredData;
            return result;
        } else {
            result = this.datos;
            return result;
        }
    },
    total_valor_pendiente_filtro() {
        let result = [];
        var suma = 0;
        if (this.$refs.vuetable != null) {            
            result = this.$refs.vuetable.allFilteredData;            
        } else {
            result = this.datos;            
        }
        for(var k in result){
            suma += parseFloat(result[k]["valor_comercial_pendiente"]);
        }
        return suma;
    },
    suma_saldo_iva_filtro() {
        let result = [];
        var suma = 0;
        if (this.$refs.vuetable != null) {            
            result = this.$refs.vuetable.allFilteredData;            
        } else {
            result = this.datos;            
        }
        for(var k in result){
            suma += parseFloat(result[k]["saldo_iva"]);
        }
        return suma;
    },
    suma_saldo_ieps_filtro() {
        let result = [];
        var suma = 0;
        if (this.$refs.vuetable != null) {            
            result = this.$refs.vuetable.allFilteredData;            
        } else {
            result = this.datos;            
        }
        for(var k in result){
            suma += parseFloat(result[k]["saldo_ieps"]);
        }
        return suma;
    },
  },
  data: () => ({
    lista_mensajes: [
            "AGRADECEMOS SU PACIENCIA..",
            "PROCESANDO LOS CARGOS..",
            "VERIFICANDO IDENTIFICADORES..", 
            "VALIDACIÓN DE FORMAS DE PAGO..", 
            "PROCESANDO INVENTARIOS INICIALES..",            
            "PROCESANDO ABONOS A LA FECHA..", 
            "VERIFICANDO FRACCIONES..",
            "GESTIONANDO SALDOS POR FRACCIÓN..", 
            "TOTALIZANDO VALOR COMERCIAL PENDIENTE DE RETORNO..",
        ],
    fecha_actualizacion: "",
    suma_saldo_ieps:0,
    suma_saldo_iva:0,
    total_valor_pendiente:0,
    conteo_total:0,
    conteo_vista_previa:0,
    fecha_actual:"",
    anio_loading:false,
    plazo_loading:false,
    clave_loading:false,
    claves:[],
    anios:[],
    reglas_plazo: [],
    meses:[
        {"id":1,"mes":"ENERO"}, 
        {"id":2,"mes":"FEBRERO"},
        {"id":3,"mes":"MARZO"},
        {"id":4,"mes":"ABRIL"},
        {"id":5,"mes":"MAYO"},
        {"id":6,"mes":"JUNIO"},
        {"id":7,"mes":"JULIO"},
        {"id":8,"mes":"AGOSTO"},
        {"id":9,"mes":"SEPTIEMBRE"},
        {"id":10,"mes":"OCTUBRE"},
        {"id":11,"mes":"NOVIEMBRE"},
        {"id":12,"mes":"DICIEMBRE"}],
    permisoEliminar:false,
    list_activos:[
        {"id":"N","text":"No"}, //No Activo Fijos
        {"id":"S","text":"Si"}, //Activo Fijo
        {"id":"","text":"Todos"}],
    fracciones: [],
    fab: false,
    rfc: '',
    tipo: '',
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Auditorías",
        disabled: true,
        to: ""
      },
      {
        text: "Computo de Plazos",
        disabled: true,
        to: ""
      }
    ],
    datos: [],
    reportes: [],    
    encabezadosExportarCompletas:{
        "Numero de Pedimento": "no_pedimento",
        "Tipo de Pedimento": "tipo_pedimento",                                            
        "Clave Documento":"clave_documento",
        "Fecha Pago Real": "fecha" ,
        "Fecha Pago Original": "fecha_original",  
        "Fraccion Arancelaria": "fraccion",  
        "ID Activo": "identificador",
        "Origen":"origen",
        "Valor Comercial CARGO":"valor_comercial",
        "Valor Comercial CARGO Acumulado x FA":"valor_comercial_cargo",
        "Valor Comercial ABONO":"abono",
        "Valor Comercial ABONO Acumulado x FA":"valor_comercial_abono",
        "Abono IVA":"abono_iva",
         "Abono IEPS":"abono_ieps",
        "Valor Comercial pendiente de retorno":"valor_comercial_pendiente",
        "Crédito IVA":"saldo_iva",
        "Crédito IEPS":"saldo_ieps",
        "Meses Transcurridos":"meses",
        "Regla de Plazo":"regla_plazo",
        "Fecha de Vencimiento":"fecha_vencimiento",
    },
    encabezadosExportar:{
        "Numero de Pedimento": "no_pedimento",
        "Tipo de Pedimento": "tipo_pedimento",                                            
        "Clave Documento":"clave_documento",
        "Fecha Pago Real": "fecha" ,
        "Fecha Pago Original": "fecha_original",  
        "Fraccion Arancelaria": "fraccion",  
        "ID Activo": "identificador",
        "Origen":"origen",
        "Valor Comercial CARGO":"valor_comercial",
        "Valor Comercial ABONO":"abono",
        "Abono IVA":"abono_iva",
         "Abono IEPS":"abono_ieps",
        "Valor Comercial pendiente de retorno":"valor_comercial_pendiente",
        "Crédito IVA":"saldo_iva",
        "Crédito IEPS":"saldo_ieps",
        "Meses Transcurridos":"meses",
        "Regla de Plazo":"regla_plazo",
        "Fecha de Vencimiento":"fecha_vencimiento",
    },
    columns_completas: [
            "no_pedimento",            
            "tipo_pedimento",
            "fecha",
            "fecha_original",
            "clave_documento",
            "fraccion",            
            "identificador",
            "origen",
            "valor_comercial",
            "valor_comercial_cargo",
            "abono",
            "valor_comercial_abono",
            "abono_iva",
            "abono_ieps",
            "valor_comercial_pendiente",
            "saldo_iva",
            "saldo_ieps",
            "meses",
            "regla_plazo",
            "fecha_vencimiento",

            ],
        columns_sin_acumulado: [
            "no_pedimento",            
            "tipo_pedimento",
            "fecha",
            "fecha_original",
            "clave_documento",
            "fraccion",            
            "identificador",
            "origen",
            "valor_comercial",
            "abono",
            "abono_iva",
            "abono_ieps",
            "valor_comercial_pendiente",
            "saldo_iva",
            "saldo_ieps",
            "meses",
            "regla_plazo",
            "fecha_vencimiento",

            ],
    columns: [
            "no_pedimento",            
            "tipo_pedimento",
            "fecha",
            "fecha_original",
            "clave_documento",
            "fraccion",            
            "identificador",
            "origen",
            "valor_comercial",
            "abono",
            "abono_iva",
            "abono_ieps",
            "valor_comercial_pendiente",
            "saldo_iva",
            "saldo_ieps",
            "meses",
            "regla_plazo",
            "fecha_vencimiento",

            ],
    options: {
      filterable: true,
      sortable: [],

      headings: {
        "no_pedimento": "Numero de Pedimento",
        "tipo_pedimento": "Tipo de Pedimento",                                            
        "clave_documento": "Clave Documento",
        "fecha": "Fecha Pago Real",
        "fecha_original": "Fecha Pago Original",                
        "fraccion": "Fraccion Arancelaria",                            
        "identificador": "ID Activo",
        "origen":"Origen",
        "valor_comercial":"Valor Comercial CARGO",
        "valor_comercial_cargo": "Valor Comercial CARGO Acumulado x FA",
        "abono":"Valor Comercial ABONO",
        "valor_comercial_abono": "Valor Comercial ABONO Acumulado x FA",
        "abono_iva": "Abono IVA",
        "abono_ieps": "Abono IEPS",
        "valor_comercial_pendiente":"Valor Comercial pendiente de retorno",
        "saldo_iva": "Crédito IVA",
        "saldo_ieps": "Crédito IEPS",
        "meses":"Meses Transcurridos",
        "regla_plazo":"Regla de Plazo",
        "fecha_vencimiento":"Fecha de Vencimiento",
      }
    },
    columns_reportes: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options_reportes: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    loading: false,
    show_loading: true,
    list_reportes: [
            {
                "reporte": "Pref. Arancelarias Activo Fijo WS",
                "url": "/reportes_ws/partidas_activo_fijo/"
            },
            {
                "reporte": "Pref. Arancelarias Activo Fijo DS",
                "url": "/reportes_ds/partidas_activo_fijo_ds/"
            },            
    ],
    listado:"",
    listado_fracciones:"",
    dialog1:false,
    dialog2:false,
    dialog3:false,
    dialog4:false,
    model: {
      rfc: "",
      usuario: "",
      fecha_de: "",
      fecha_a:"",      
      activo: "",
      fraccion: "",
      numero_pedimento:"",
      lista:[],
      fraccion_lista:[],
      clave_documento:"",   
      valor_pendiente:"Valor Pendiente de Retorno",
      regla_plazo:""   
    },
    valor_pendiente_array:[
        'Valor Pendiente de Retorno',
        'TODOS'
    ],

    selecciona_todo8: false,
    selecciona_todo8_partida: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,

  }),
  methods: {   
    set_columns:function(){
      //Humberto solicitó que si se elige con Valor Pendiente de Retorno, no se muestren las columnas de Acumulado
      if(this.model.valor_pendiente == "Valor Pendiente de Retorno"){
        delete(this.encabezadosExportar["Valor Comercial CARGO Acumulado x FA"]);
        delete(this.encabezadosExportar["Valor Comercial ABONO Acumulado x FA"]);
        this.columns = JSON.parse(JSON.stringify(this.columns_sin_acumulado));        
      } else {
        this.encabezadosExportar = JSON.parse(JSON.stringify(this.encabezadosExportarCompletas));
        this.columns = JSON.parse(JSON.stringify(this.columns_completas));
      }
    },
    cargar: function(opcion="") {
        if(opcion != "inicio")
            this.$root.$dialogLoader.show('Espere un momento por favor..');
      let data = {
        rfc: this.model.rfc,
        tipo: "COMPUTO PLAZOS"
      };
      axios.post(this.$apiSA31 + "soluciona31/reportes/get_reportes/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.reportes = res.data;
            this.reportes.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud)
            });
            for (var k in this.reportes) {
              this.reportes[k].fecha_solicitud = this.parseDate(this.reportes[k].fecha_solicitud);
              this.reportes[k].fecha_generacion = this.parseDate(this.reportes[k].fecha_generacion);
              this.reportes[k].estatus = this.getEstatus(this.reportes[k].estatus);
              this.reportes[k].criterio = this.getCriterioPredeterminados(this.reportes[k].criterio);
            }
          }
        })
        .catch(err => {

        }).then(() => {
            if(opcion != "inicio")
                this.$root.$dialogLoader.hide();
        });
    },
    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores",
        "No Recuperable", "Token Incorrecto", "Reprogramado", , "Pendiente AA"
      ];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminados: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          
            if (params.lista != undefined && params.lista.length > 0) {
              return "Buscado por lista de pedimentos: " + params.lista.length;
            } else if (params.numero_pedimento && params.numero_pedimento != ""){
              return "Pedimento: " + params.numero_pedimento;
            }else {
              var txt = "";
              if (params.fecha_de && params.fecha_de != "")
                  txt += "Fecha De: " + params.fecha_de+", ";
              if (params.fecha_a && params.fecha_a != "")
                  txt += " Fecha A: " + params.fecha_a+", ";
              if (params.fraccion && params.fraccion != "")
                  txt += " Fracción: " + params.fraccion+", ";
              if (params.activo && params.activo != "")
                  txt += " Activo: " + params.activo+", ";
              if (params.clave_documento && params.clave_documento != "")
                  txt += " Clave Doc: " + params.clave_documento;                        
              return txt;
            }
              
          
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }

    },
    validaDiasPreview: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
        if (Math.abs(diferencia) > 365)
          return "Periodo máximo de consulta 365 dias. Favor de verificar."
      }
      return true;
    },
    validaDias: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
        if (Math.abs(diferencia) > 366)
          return "Periodo máximo de reporte 365 días. Favor de verificar."
      }
      return true;
    },
    validaPedimento: function(val){
      if (val && val!="" && !this.validarPatronPedimento(val))
          return "Pedimento no válido. Ejemplo: 240-0123-0000123";
      return true;
    },
    validarPatronPedimento(pedimento) {
      const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
      return patternPedimento.test(pedimento);
    },
    validaListadoPreview: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 pedimento. Favor de verificar.";
      } else if (listadoSinEspacios.length > 15) {
        return "No se puede consultar mas de 15 pedimentos en Vista Previa";
      } else {
        for (var k in listadoSinEspacios) {
          if (!this.validarPatronPedimento(listadoSinEspacios[k]))
            return "Verificar pedimentos no válidos. Ejemplo: 240-0123-0000123";
        }
      }

      return true;
    },
    validaListado: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 pedimento. Favor de verificar.";
      } else if (listadoSinEspacios.length > 50) {
        return "No se puede consultar mas de 50 pedimentos";
      } else {
        for (var k in listadoSinEspacios) {
          if (!this.validarPatronPedimento(listadoSinEspacios[k]))
            return "Verificar pedimentos no válidos. Ejemplo: 240-0123-0000123";
        }
      }

      return true;
    },
    validaListadoFraccionPreview: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado_fracciones);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 fracción. Favor de verificar.";
      } else if (listadoSinEspacios.length > 5) {
        return "No se puede consultar mas de 5 fracciones en Vista Previa";
      } 
      return true;
    },
    validaListadoFraccion: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado_fracciones);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 fracción. Favor de verificar.";
      } else if (listadoSinEspacios.length > 15) {
        return "No se puede consultar mas de 15 fracciones";
      }

      return true;
    },
    
    removerLineasVacias(listado) {
      var listadoSplit = listado.split("\n");
      var listadoSinEspacios = listadoSplit.filter(item => {
        return item.trim() != "";
      });
      listadoSinEspacios = listadoSinEspacios.map(item => {
        return item.trim();
      });
      return listadoSinEspacios;
    },
    generaConsultaListado() {
      if (this.$refs.formListado.validate()) {
        this.genera_consulta("listado");        
        this.dialog1 = false;        
      }
    },
    generaReporteListado() {
      if (this.$refs.formListado.validate()) {
        this.generar_reporte("listado");        
        this.dialog2 = false;
      }
    },
    generaConsultaListadoFracciones() {
      if (this.$refs.formListadoFracciones.validate()) {
        this.genera_consulta("listado_fracciones");        
        this.dialog3 = false;        
      }
    },
    generaReporteListadoFracciones() {
      if (this.$refs.formListadoFracciones.validate()) {
        this.generar_reporte("listado_fracciones");        
        this.dialog4 = false;
      }
    },
    formatNumberDec: function(numero, decimales){
        if (numero == undefined || numero == null || numero == "")
            numero = 0;
        numero = Number(numero);
        if (isNaN(numero)){
            return "";
        } else
            return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    formatNumber: function(numero){
        if (numero == undefined || numero == null || numero == "")
            numero = 0;
        numero = Number(numero);
        if (isNaN(numero)){
            return "";
        } else
            return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");                                    
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      try{
          if (!date) return null;
          return moment(String(date)).subtract(6, 'hours').format('YYYY-MM-DD HH:mm:ss');
      } catch(error){
        console.log("FECHA ERROR: ", error);
      }
      
    },
    getFracciones:function(){
       this.$root.$dialogLoader.show('Espere un momento por favor..');
        var data = {
            "identificador": this.model.activo, //identificador de activo fijo N -> No, S -> Si, "" -> Todos
            "rfc": this.model.rfc
        };
        
        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/get_fracciones_inventario/",            
            data: data
          })
          .then(response => {
                if(response.data && response.data.length){
                    this.fracciones = response.data
                } else {
                    this.fracciones = [];
                }                    
          }).catch(error => {            
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al obtener las fracciones. Intente nuevamente.",
              footer: ""
            });
          }).then(() => {            
            this.$root.$dialogLoader.hide();
          }); 
    },
    getClaves:function(){
       this.clave_loading = true;
        var data = {
            //"identificador": this.model.activo, //identificador de activo fijo N -> No, S -> Si, "" -> Todos
            "rfc": this.model.rfc
        };
        
        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/get_claves_documento_a31/",            
            data: data
          })
          .then(response => {
                if(response.data && response.data.length){
                    this.claves = response.data
                } else {
                    this.claves = [];
                }                    
          }).catch(error => {            
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al obtener las claves documentos. Intente nuevamente.",
              footer: ""
            });
          }).then(()=>{
            this.clave_loading = false;
          }); 
    },
    getAnios:function(){
       this.anio_loading = true;
        var data = {
            //"identificador": this.model.activo, //identificador de activo fijo N -> No, S -> Si, "" -> Todos
            "rfc": this.model.rfc
        };
        
        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/get_anios_a31/",            
            data: data
          })
          .then(response => {
                if(response.data && response.data.length){
                    this.anios = response.data
                } else {
                    this.anios = [];
                }                    
          }).catch(error => {            
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al obtener los años. Intente nuevamente.",
              footer: ""
            });
          }).then(()=>{
            this.model.anio = parseInt(moment().format('YYYY'));            
            if(!this.anios.includes(this.model.anio) && this.anios.length>0){
                this.model.anio = this.anios[this.anios.length - 1];                
            }
            this.anio_loading = false;
          }); 
    },
    getReglasPlazo:function(){
       this.plazo_loading = true;
        var data = {
            "id_cliente": this.$local_storage.get("id_cliente")
        };
        
        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/get_plazos_cliente/",            
            data: data
          })
          .then(response => {
                if(response.data && response.data.length){
                    this.reglas_plazo = response.data
                } else {
                    this.reglas_plazo = [];
                }                    
          }).catch(error => {            
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al obtener las Reglas de Plazo. Intente nuevamente.",
              footer: ""
            });
          }).then(()=>{
            this.plazo_loading = false;
          }); 
    },
    generar_reporte(opcion="") {
      if (!this.$refs.formreporte.validate() && opcion=="") {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('Espere un momento por favor..');
        var data = JSON.parse(JSON.stringify(this.model)); 

        data["reporte_url"] = "/soluciona31/reportes/rpt_computo_plazos/";
        data["nombre_reporte"] = "Computo Plazos";
        data["tipo"] = "COMPUTO PLAZOS";

        if( opcion == "listado"){
          data["lista"] = this.removerLineasVacias(this.listado);
          delete(data['numero_pedimento']);
          delete(data['fecha_de']);
          delete(data['fecha_a']);
          delete(data['fraccion_lista']);
        } else if( opcion == "listado_fracciones"){
            data["fraccion_lista"] = this.removerLineasVacias(this.listado_fracciones);                        
            delete(data['numero_pedimento']);
            delete(data['fecha_de']);
            delete(data['fecha_a']);             
            delete(data['lista']);
        } else {
          delete(data['lista']);
          delete(data['fraccion_lista']);
        }                     

        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/save_reporte/",                                 
            data: data
          })
          .then(response => {            
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          }).then(() => {            
            this.$root.$dialogLoader.hide();
            this.cargar();
            
          });
      }
    },
    genera_consulta(opcion="") {
      if (!this.$refs.form.validate() && opcion=="") {
        //Alguna operación o mensaje
      } else {                 
        this.$refs.computoLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.datos = [];
        var data = JSON.parse(JSON.stringify(this.model)); 

        if( opcion == "listado"){
          data["lista"] = this.removerLineasVacias(this.listado);
          delete(data['numero_pedimento']);
          delete(data['fecha_de']);
          delete(data['fecha_a']);
          delete(data['fraccion_lista']);
        } else if( opcion == "listado_fracciones"){
          data["fraccion_lista"] = this.removerLineasVacias(this.listado_fracciones);                           
          delete(data['numero_pedimento']);
          delete(data['fecha_de']);
          delete(data['fecha_a']);
          delete(data['lista']);
        } else {
          delete(data['lista']);
          delete(data['fraccion_lista']);
        }
        
        console.log("DATA: ", data);        
        //return false;

        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/computo_plazos_preview/",
            //url: "http://127.0.0.1:7000/soluciona31/reportes/computo_plazos_preview/",
            data: data
          })
          .then(response => {
            this.suma_saldo_ieps = 0;
            this.suma_saldo_iva = 0;
            this.total_valor_pendiente = 0;
            this.conteo_total = 0;
            this.conteo_vista_previa = 0;

            this.datos = response.data["pedimentos"]; 
            this.total_valor_pendiente = response.data["suma_valor_pendiente"];
            this.suma_saldo_iva = response.data["suma_saldo_iva"];
            this.suma_saldo_ieps = response.data["suma_saldo_ieps"];
            this.conteo_vista_previa = this.datos.length;
            this.conteo_total = response.data["total_registros"];
            for(var k in this.datos){
                this.datos[k]["fecha"] = this.parseDate(this.datos[k]["fecha"]);
                this.datos[k]["fecha_original"] = this.parseDate(this.datos[k]["fecha_original"]);
                this.datos[k]["fecha_vencimiento"] = this.parseDate(this.datos[k]["fecha_vencimiento"]);
            }
          })
          .catch(error => {
            var mensaje = "";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;              
            } 
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al generar la consulta",
              footer: mensaje
            });
          }).then(() => {            
            this.$refs.computoLoader.hide();
          });
      }
    },
    calcular_plazos: function(){
      this.$swal({
        type: "info",
        title: "¡Importante!",
        text: "Se generará el computo de plazos de los pedimentos de 2015 a la fecha e inventario inicial ¿Desea continuar?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
            this.$refs.computoLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          
            let data = {
              "rfc": this.$local_storage.get("rfc"),
              "usuario": this.$local_storage.get("id_usuario")          
            };

            axios({
                method: "post",
                url: this.$apiSA31 + "soluciona31/reportes/calcular_computo_plazos/",
                //url: "http://127.0.0.1:7000/soluciona31/reportes/calcular_computo_plazos/",
                data: data
              })
              .then(response => {
                this.get_primer_consulta();
                
              })
              .catch(error => {
                var mensaje = "";
                if (typeof error.response !== "undefined") {
                  mensaje = error.response.data.mensaje;              
                } 
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un error al generar el cálculo. Favor de comunicarse con Soporte.",
                  footer: mensaje
                });
              }).then(() => {            
                this.$refs.computoLoader.hide();
              });     
        }
      });         
    },
    get_primer_consulta: function(){                        
        this.$root.$dialogLoader.show('Espere un momento por favor..');
        
        var data = JSON.parse(JSON.stringify(this.model)); 
        data['fecha_de'] = "2015-01-01";
        data['fecha_a'] = moment().format("YYYY-MM-DD"); //fecha actual
        delete(data['numero_pedimento']);
        delete(data['fraccion_lista']);
        delete(data['lista']);

        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/computo_plazos_preview/",
            //url: "http://127.0.0.1:7000/soluciona31/reportes/computo_plazos_preview/",
            data: data
          })
          .then(response => {
            this.suma_saldo_ieps = 0;
            this.suma_saldo_iva = 0;
            this.total_valor_pendiente = 0;
            this.conteo_total = 0;
            this.conteo_vista_previa = 0;
            this.fecha_actualizacion = "";

            console.log("RESPONSE: ", response);
            if(response.data["pedimentos"]){
                  this.datos = response.data["pedimentos"]; 
                  this.total_valor_pendiente = response.data["suma_valor_pendiente"];
                  this.suma_saldo_iva = response.data["suma_saldo_iva"];
                  this.suma_saldo_ieps = response.data["suma_saldo_ieps"];
                  this.conteo_vista_previa = this.datos.length;
                  this.conteo_total = response.data["total_registros"];
                  this.fecha_actualizacion = this.parseDateTime(response.data["fecha_actualizacion"]);
                  for(var k in this.datos){
                      this.datos[k]["fecha"] = this.parseDate(this.datos[k]["fecha"]);
                      this.datos[k]["fecha_original"] = this.parseDate(this.datos[k]["fecha_original"]);
                      this.datos[k]["fecha_vencimiento"] = this.parseDate(this.datos[k]["fecha_vencimiento"]);
                  }
            } else {
                this.$swal({
                  type: "info",
                  title: "¡Datos no encontrados!",
                  text: "No se ha generado el cálculo de Plazos. Por favor genere éste dando click en el botón Calcular Plazos",
                  footer: ""
                });
            }

            
          })
          .catch(error => {
            var mensaje = "";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;              
            } 
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al generar la consulta",
              footer: mensaje
            });
          }).then(() => {            
            this.$root.$dialogLoader.hide();
          });      
    },

    downloadReporte: function(key) {
      this.$root.$dialogLoader.show('Espere un momento por favor..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('Espere un momento por favor..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$apiSA31 + 'soluciona31/reportes/eliminar_reporte/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargar();
            });
        }
      });
    },
 
    
  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}
</style>
